import md from '@/routes/middlewares';

import RouterViewPage from '@/views/RouterViewPage.vue';
import AdminProductsPage from '@/views/admin/configuration/AdminProductsPage.vue';
import Product from '@/views/admin/configuration/Product.vue';
import ProductPage from '@/views/admin/configuration/ProductPage.vue';
import Procedures from '@/views/admin/configuration/Procedures';
import Analyses from '@/views/admin/configuration/analyses/Analyses.vue';
import Categories from '@/views/admin/configuration/analyses/Categories';
import Types from '@/views/admin/configuration/analyses/Types';
import Groups from '@/views/admin/configuration/analyses/Groups';
import WorkOrderTypes from '@/views/admin/configuration/workOrderTypes/WorkOrderTypes';
import MaintenanceSchedule from '@/views/admin/configuration/maintenanceSchedule/MaintenanceSchedule';
import TreatmentControls from '@/views/admin/configuration/treatmentControls/TreatmentControls';
import ReportTypes from '@/views/admin/configuration/ReportTypes';
import DocumentTypes from '@/views/admin/configuration/DocumentTypes';
import CouponManagement from '@/views/admin/configuration/CouponManagement.vue';
import ServiceProvider from '@/views/admin/configuration/ServiceProvider';
import ProductContainer from '@/views/admin/configuration/ProductContainer.vue';
import ProductsCategories from '@/views/admin/configuration/ProductsCategories.vue';
import ServiceProviderBilling from '@/views/admin/configuration/ServiceProviderBilling.vue';
import CorrectiveActions from '@/views/admin/configuration/analyses/CorrectiveActions.vue';
import Erp from '@/views/admin/configuration/Erp.vue';
import GptFileUpload from '@/views/admin/configuration/GptFileUpload.vue';

const configuration = {
    path: 'configuration',
    component: RouterViewPage,
    children: [
        {
            path: 'procedures',
            name: 'procedures',
            component: Procedures,
        },
        {
            path: 'products',
            name: 'products',
            component: AdminProductsPage,
        },
        {
            path: 'maintenanceSchedule',
            name: 'adminMaintenanceSchedule',
            component: MaintenanceSchedule,
        },
        {
            path: 'gptconfig',
            name: 'gptconfig',
            component: GptFileUpload,
        },
        {
            path: 'treatmentControls',
            name: 'treatmentControls',
            component: TreatmentControls,
        },
        {
            path: 'reportTypes',
            name: 'reportTypes',
            component: ReportTypes,
        },
        {
            path: 'documentTypes',
            name: 'documentTypes',
            component: DocumentTypes,
        },
        {
            path: 'serviceProviderInfo',
            name: 'serviceProviderInfo',
            component: ServiceProvider,
        },
        {
            path: 'products/:productId',
            component: ProductPage,
            redirect: { name: 'product' },
            meta: {
                middlewares: [md.getProductInfo],
            },
            children: [
                {
                    path: 'info',
                    name: 'product',
                    component: Product,
                },
            ],
        },
        {
            path: 'analyses',
            name: 'analyses',
            component: Analyses,
            children: [
                {
                    path: 'analysesCategories',
                    name: 'analysesCategories',
                    component: Categories,
                },
                {
                    path: 'analysesTypes',
                    name: 'analysesTypes',
                    component: Types,
                },
                {
                    path: 'analysesGroups',
                    name: 'analysesGroups',
                    component: Groups,
                },
                {
                    path: 'correctiveActions',
                    name: 'correctiveActions',
                    component: CorrectiveActions,
                },
            ],
        },
        {
            path: 'workOrderTypes',
            name: 'workOrderTypes',
            component: WorkOrderTypes,
        },
        {
            path: 'coupons',
            name: 'coupons',
            component: CouponManagement,
        },
        {
            path: 'productContainer',
            name: 'productContainer',
            component: ProductContainer,
        },
        {
            path: 'productsCategories',
            name: 'productsCategories',
            component: ProductsCategories,
        },
        {
            path: 'serviceProviderBilling',
            name: 'serviceProviderBilling',
            component: ServiceProviderBilling,
        },
        {
            path: 'erp',
            name: 'erp',
            component: Erp,
        },
    ],
};

export default configuration;
